<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/hr/work-schedules">
                    <icon name="clock"></icon>
                    ตารางเวลา
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/hr/holidays">
                    <icon name="calendar"></icon>
                    วันหยุดนักขัตฤกษ์
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/hr/leave-day">
                    <icon name="calendar-alt"></icon>
                    ตั้งค่าวันลา
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/hr/shift">
                    <icon name="calendar"></icon>
                    ตั้งค่าตารางการทำงาน
                </b-nav-item>&nbsp;
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "work-schedule-layout"
    }
</script>

<style scoped>

</style>